export enum CategoryType {
    ClinicalExam = 1,
    CaseHistory = 2,
    SuggestedInvestigation = 3,
    Diagnosis = 4,
    LabReport = 5,
    SiteImages = 6,
}

export const CategoryTypeLabels: Record<CategoryType, string> = {
    [CategoryType.ClinicalExam]: "Clinical Exam",
    [CategoryType.CaseHistory]: "Case History",
    [CategoryType.SuggestedInvestigation]: "Suggested Investigation",
    [CategoryType.Diagnosis]: "Diagnosis",
    [CategoryType.LabReport]: "Lab Report",
    [CategoryType.SiteImages]: "Site Images",
};